import { $themeBreakpoints } from '@themeConfig'

export default {
  namespaced: true,
  state: {
    visitors: 1,
    cacheDocuments: {},
    windowWidth: 0,
    shallShowOverlay: false,
  },
  getters: {
    currentBreakPoint: state => {
      const { windowWidth } = state
      if (windowWidth >= $themeBreakpoints.xl) return 'xl'
      if (windowWidth >= $themeBreakpoints.lg) return 'lg'
      if (windowWidth >= $themeBreakpoints.md) return 'md'
      if (windowWidth >= $themeBreakpoints.sm) return 'sm'
      return 'xs'
    },
  },
  mutations: {
    UPDATE_WINDOW_WIDTH(state, val) {
      state.windowWidth = val
    },
    TOGGLE_OVERLAY(state, val) {
      state.shallShowOverlay = val !== undefined ? val : !state.shallShowOverlay
    },
    CACHE_DOCUMENT(state, val) {
      if (val) {
        state.cacheDocuments[val.fileID] = {}
        state.cacheDocuments[val.fileID] = val.url
      }
    },
    PURGE_CACHE(state, val) {
      if (val) {
        state.cacheDocuments = {}
      }
    },
    SOCKET_UPDATE_VISITORS(state, val) {
      if (val) {
        state.visitors = val
      }
    },
  },
  actions: {},
}
